import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { LinePayload } from '../common/payload.types';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { submittedQuotationSchema } from './schemas';
import { quotationQueryOptions } from './useQuotation';

export type Payload = {
  brandId: number;
  clientContactId: number;
  clientId: number;
  coEntryNumber: string;
  conditionId: number | null;
  customAgreementId: number | null;
  customConditionId: number | null;
  description: string;
  expirationDate: string;
  introduction: string;
  mail: string;
  quotationLines: LinePayload[];
  specialConditions: string | null;
  title: string;
};

export const useUpdateQuotation = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: Payload) => {
      const { data: quotation } = await fetchJson(`/quotations/${id}`, {
        method: 'PATCH',
        schema: apiResourceSchema(submittedQuotationSchema),
        body,
      });

      return quotation;
    },
    onSuccess: (updatedQuotation) => {
      queryClient.setQueryData(quotationQueryOptions(updatedQuotation.id).queryKey, () => updatedQuotation);

      queryClient.invalidateQueries({ queryKey: QueryKeys.quotations.show.id(id) });
      queryClient.invalidateQueries({ queryKey: QueryKeys.quotations.index.root });
      queryClient.invalidateQueries({ queryKey: QueryKeys.statistics.dashboard });
    },
  });
};
